import * as AccordionRadix from "@radix-ui/react-accordion";

import TriggerElement from "./trigger/trigger";
import ContentElement from "./content/content";
import ItemElement from "./item/item";

export const Root = AccordionRadix.Root;
export const Trigger = TriggerElement;
export const Item = ItemElement;
export const Content = ContentElement;
